'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBulkSelectionState;

var _getCurrentSelectionLength = require('./getCurrentSelectionLength');

var _getCurrentSelectionLength2 = _interopRequireDefault(_getCurrentSelectionLength);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getBulkSelectionState() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var maxRowSelection = params.maxRowSelection,
      _params$selectedRowsK = params.selectedRowsKeys,
      selectedRowsKeys = _params$selectedRowsK === undefined ? {} : _params$selectedRowsK;
  var selected = (0, _getCurrentSelectionLength2.default)(selectedRowsKeys);

  if (selected === 0) {
    return 'none';
  } else if (selected === maxRowSelection) {
    return 'all';
  }

  return 'some';
}